<template>
  <input
    ref="inputRef"
    :type="type"
    :class="inputClass"
    :placeholder="placeholder"
    :readonly="readonly"
    :required="required"
  />
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import IMask from 'imask';

const props = defineProps({
  modelValue: { type: [String, Number], default: '' },
  mask: { type: String, default: null },
  maskOptions: { type: Object, default: () => ({}) },
  type: { type: String, default: 'text' },
  inputClass: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  readonly: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const inputRef = ref(null);
let maskInstance = null;

function getMaskConfig() {
  switch (props.mask) {
    case 'currency':
      return {
        mask: '$num',
        blocks: {
          num: { mask: Number, thousandsSeparator: ',' },
        },
      };
    case 'phone':
      return { mask: '0000-0000' };
    case 'dui':
      return { mask: '00000000-0' };
    case 'nit':
      return { mask: '0000-000000-000-0' };
    case 'custom':
      return { mask: props.maskOptions.pattern || '0000-0000' };
    default:
      return null;
  }
}

function setupMask() {
  if (!props.mask || !inputRef.value) return;

  const config = getMaskConfig();
  if (!config) return;

  maskInstance = IMask(inputRef.value, config);

  if (props.modelValue) {
    maskInstance.unmaskedValue = String(props.modelValue);
  }

  maskInstance.on('accept', () => {
    emit('update:modelValue', maskInstance.unmaskedValue);
  });
}

function destroyMask() {
  if (maskInstance) {
    maskInstance.destroy();
    maskInstance = null;
  }
}

watch(
  () => props.modelValue,
  (newVal) => {
    if (maskInstance && maskInstance.unmaskedValue !== String(newVal ?? '')) {
      maskInstance.unmaskedValue = String(newVal ?? '');
    }
  },
);

onMounted(setupMask);
onUnmounted(destroyMask);
</script>
